import { useEffect, useState } from 'react';

// Matches the smallest responsive band. Anonymous users still see the landing
// page here, while authenticated users render the compact app shell.
export const MOBILE_VIEWPORT_QUERY = '(max-width: 768px)';

export default function useIsMobileViewport() {
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined'
      ? window.matchMedia(MOBILE_VIEWPORT_QUERY).matches
      : false
  ));

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_VIEWPORT_QUERY);
    const sync = () => setIsMobile(mediaQuery.matches);
    sync();
    mediaQuery.addEventListener('change', sync);
    return () => mediaQuery.removeEventListener('change', sync);
  }, []);

  return isMobile;
}
